// src/redux/entitlementsSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchMe } from "../services/meService"; // adjust path to where fetchMe lives

const initialState = {
  loading: false,
  error: null,
  data: null, // entitlements
  lastFetchedAt: 0,
};

export const fetchEntitlementsAsync = createAsyncThunk(
  "entitlements/fetch",
  async (_, { rejectWithValue }) => {
    try {
      // fetchMe() already uses apiRequest("/me","GET")
      const me = await fetchMe();
      return me?.entitlements || null;
    } catch (e) {
      return rejectWithValue(String(e?.message || e));
    }
  }
);

const entitlementsSlice = createSlice({
  name: "entitlements",
  initialState,
  reducers: {
    clearEntitlements(state) {
      state.loading = false;
      state.error = null;
      state.data = null;
      state.lastFetchedAt = 0;
    },
    setEntitlements(state, action) {
      state.loading = false;
      state.error = null;
      state.data = action.payload || null;
      state.lastFetchedAt = Date.now();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEntitlementsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEntitlementsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.data = action.payload;
        state.lastFetchedAt = Date.now();
      })
      .addCase(fetchEntitlementsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || action.error?.message || "Failed to load entitlements";
      });
  },
});

export const { clearEntitlements, setEntitlements } = entitlementsSlice.actions;
export default entitlementsSlice.reducer;

// ---------------- selectors ----------------
export const selectEntitlements = (s) => s.entitlements?.data || null;
export const selectEntitlementsLoading = (s) => Boolean(s.entitlements?.loading);
export const selectEntitlementsError = (s) => s.entitlements?.error || null;
export const selectEntitlementsLastFetchedAt = (s) =>
  s.entitlements?.lastFetchedAt || 0;

export const selectPlanCode = (s) => {
  const e = selectEntitlements(s);
  return String(e?.planCode || "free").toLowerCase();
};

export const selectCan = (s) => selectEntitlements(s)?.can || {};
export const selectLimits = (s) => selectEntitlements(s)?.limits || {};
export const selectUsage = (s) => selectEntitlements(s)?.usage || {};

export const selectCanDo = (s, capability) => {
  const can = selectCan(s);
  return can?.[capability] === true;
};
